module.exports = __webpack_public_path__ + "static/media/bmw.aeb7389c.webp";